import React from "react";

// 3-stage progress dots: ● ━ ● ━ ○
export function StageProgress({ current = "idiom", isResult = false, className = "" }) {
  // "idiom" -> stage 1, "meaning" -> 2, "context" -> 3
  const stageIdx = { idiom: 1, meaning: 2, context: 3 }[current] || 1;
  const labels = [
    { key: "idiom", icon: "🎧", label: "Deyimi Yakala" },
    { key: "meaning", icon: "💭", label: "Anlamını Yakala" },
    { key: "context", icon: "🧠", label: "Bağlamı Yakala" },
  ];
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="stage-progress">
      {labels.map((l, i) => {
        const n = i + 1;
        const done = n < stageIdx;
        const active = n === stageIdx;
        return (
          <React.Fragment key={l.key}>
            <div className="flex items-center gap-2">
              <span
                className={`h-3 w-3 rounded-full transition-all ${
                  active ? "bg-cyan-300 shadow-[0_0_16px_rgba(5,217,232,0.7)] scale-110"
                         : done ? "bg-emerald-400" : "bg-white/15 border border-white/25"
                }`}
                aria-label={`${n}. ${l.label} ${active ? "aktif" : done ? "tamamlandı" : "sırada"}`}
              />
              <span className={`text-[11px] font-heading tracking-widest whitespace-nowrap ${
                active ? "text-cyan-300" : done ? "text-emerald-300/80" : "text-zinc-500"
              }`}>
                {n}/3 {l.label}
              </span>
            </div>
            {n < 3 && <span className="h-px w-6 bg-white/10" aria-hidden />}
          </React.Fragment>
        );
      })}
    </div>
  );
}

// Score toast — floating +1000 / speed / bonus indicator
export function ScoreToast({ items }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="fixed inset-x-0 top-16 pointer-events-none z-50 flex flex-col items-center gap-2">
      {items.map((it) => (
        <div key={it.id} className={`animate-[fadein_0.3s_ease-out] rounded-full px-4 py-2 backdrop-blur border ${
          it.type === "bonus" ? "bg-amber-500/15 border-amber-400/50 text-amber-200"
                              : it.type === "speed" ? "bg-cyan-500/10 border-cyan-400/40 text-cyan-200"
                              : "bg-emerald-500/10 border-emerald-400/40 text-emerald-200"
        }`}>
          <span className="font-heading font-bold text-lg tabular-nums">+{it.points}</span>
          <span className="ml-2 text-xs tracking-widest">{it.label}</span>
        </div>
      ))}
    </div>
  );
}
